module.exports = __webpack_public_path__ + "static/media/9.367e0727.jpg";